import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const GrupoList = (props) => <DefaultDataTable data={props} />
